import { render, staticRenderFns } from "./FeatureContent.vue?vue&type=template&id=218ebb8c"
import script from "./FeatureContent.vue?vue&type=script&lang=js"
export * from "./FeatureContent.vue?vue&type=script&lang=js"
import style0 from "./FeatureContent.vue?vue&type=style&index=0&id=218ebb8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports